import React, { useState, useEffect, useRef } from "react";
import { Form, FormGroup, Label, Input } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import PropTypes from "prop-types";

import { CircularProgress } from "../../../..";
import { AccountMode, PersonMode, showToast } from "../../../../utils/Helper";

const Questions = ({ questions: accQuestions, setPersonData, onboarding, person, services, mode, userSession }) => {
  const [questions, setQuestions] = useState(undefined);
  const [loadingSave, setLoadingSave] = useState(false);

  useEffect(() => {
    if (accQuestions) {
      setQuestions(accQuestions);
    }
  }, [accQuestions]);

  const handleSave = () => {
    const questionschanged = questions;
    if (mode === PersonMode.New) {
      setLoadingSave(true);
      const newQuestions = questionschanged.map((q) => {
        if (Number(q.NewAnswerId) > 0) {
          const newAnswers = [];
          let newA = {};
          q.PersonAnswer.forEach((a) => {
            newA = {};
            if (a.AnswerId === q.NewAnswerId) {
              newA = {
                ...a,
                AnswerIsResponse: true,
              };
            } else {
              newA = {
                ...a,
                AnswerIsResponse: false,
              };
            }
            newAnswers.push(newA);
          });
          return {
            ...q,
            NewAnswerId: 0,
            PersonAnswer: newAnswers,
          };
        }
        return { ...q };
      });
      const newPerson = { ...person, PersonQuestion: newQuestions };
      const bodyN = {
        OnboardingId: String(onboarding),
        postPerson: newPerson,
      };
      services.fetchNewPerson(bodyN, (res) => {
        if (res) {
          const body2 = {
            postPerson: newPerson,
            onboarding: onboarding,
          };
          services.fetchOnboardingPersonResult(body2, (data) => {
            if (data && data.SDTOnboardingResult) {
              setPersonData({
                ...newPerson,
                PersonProfileRiskName: data.SDTOnboardingResult.PersonProfileRisk,
                PersonRisk: data.SDTOnboardingResult.PersonRisk,
                PersonTransactionalLimit: data.SDTOnboardingResult.PersonTransactionalLimit,
              });
              setLoadingSave(false);
              showToast("Changes saved successfully");
            } else {
              setLoadingSave(false);
            }
          });
        } else {
          setLoadingSave(false);
        }
      });
    } else {
      setLoadingSave(true);
      const newQuestions = questionschanged.map((q) => {
        if (Number(q.NewAnswerId) > 0) {
          const newAnswers = [];
          let newA = {};
          q.PersonAnswer.forEach((a) => {
            newA = {};
            if (a.AnswerId === q.NewAnswerId) {
              newA = {
                ...a,
                AnswerIsResponse: true,
              };
            } else {
              newA = {
                ...a,
                AnswerIsResponse: false,
              };
            }
            newAnswers.push(newA);
          });
          return {
            ...q,
            NewAnswerId: 0,
            PersonAnswer: newAnswers,
          };
        }
        return { ...q };
      });
      const newPerson = { ...person, PersonQuestion: newQuestions };
      //HACER PROC QUE GUARDE PREGUNTAS DE PERSONAS ACTIVAS
      services.fetchPersonSuitability({ person: newPerson }, (result) => {
        if (result && result.result.Code === 200) {
          setPersonData({
            ...newPerson,
            suitabilityDescription: result.result.Description,
          });
          const newQuestions = questionschanged.map((q) => {
            if (q.NewAnswerId > 0) {
              const newAnswers = [];
              let newA = {};
              q.Answer.forEach((a) => {
                newA = {};
                if (a.AnswerId === q.NewAnswerId) {
                  newA = {
                    ...a,
                    AnswerIsResponse: true,
                  };
                } else {
                  newA = {
                    ...a,
                    AnswerIsResponse: true,
                  };
                }
                newAnswers.push(newA);
              });
              return {
                ...q,
                NewAnswerId: 0,
                Answer: newAnswers,
              };
            }
            return { ...q };
          });
          setLoadingSave(false);
        } else {
          setLoadingSave(false);
        }
      });
    }
  };

  const handleChangeAnswer = (questionIndex, answerIndex) => {
    if (!loadingSave) {
      const newQuestions = [...questions];
      if (newQuestions[questionIndex].PersonAnswer[answerIndex].AnswerIsResponse) {
        newQuestions[questionIndex].NewAnswerId = 0;
      } else {
        newQuestions[questionIndex].NewAnswerId = questions[questionIndex].PersonAnswer[answerIndex].AnswerId;
      }
      setQuestions(newQuestions);
    }
  };

  // useEffect(() => {
  //   return () => {
  //     if (mode === PersonMode.New) {
  //       handleSave();
  //     }
  //   };
  // }, []);

  // useEffect(() => {
  //   valueref.current = questions;
  // }, [questions]);

  // useEffect(() => {
  //   personref.current = person;
  // }, [personref]);

  let save = false;
  if (!questions) {
    return <CircularProgress sm />;
  }
  return (
    <div>
      {questions.map((q, qIndex) => {
        if (q.NewAnswerId > 0) {
          save = true;
        }
        return (
          <Form key={q.QuestionId}>
            <FormGroup tag="fieldset">
              <legend>{q.QuestionDescription}</legend>
              {q.PersonAnswer.map((a, aIndex) => (
                <FormGroup check key={a.AnswerId}>
                  <Label style={{ color: a.AnswerId === q.NewAnswerId ? "#36a9e1" : "black" }} check>
                    <Input
                      type="radio"
                      name="radio1"
                      defaultChecked={a.AnswerIsResponse}
                      value={a.AnswerIsResponse ? q.NewAnswerId === 0 : q.NewAnswerId === a.AnswerId}
                      onChange={() => handleChangeAnswer(qIndex, aIndex)}
                    />
                    {` ${a.AnswerDescription}`}
                  </Label>
                </FormGroup>
              ))}
            </FormGroup>
          </Form>
        );
      })}
      {userSession.IsReadOnly === false && (
        questions.length > 0 ? (
          <LaddaButton
            className="btn btn-ladda btn-primary"
            loading={loadingSave}
            disabled={!save}
            onClick={() => handleSave()}
            data-style={EXPAND_RIGHT}
          >
            Save
          </LaddaButton>
        ) : (
          <span style={{ textAlign: "center" }}>No Questions.</span>
        )
      )}
    </div>
  );
};

Questions.propTypes = {
  questions: PropTypes.array.isRequired,
  setPersonData: PropTypes.func.isRequired,
  services: PropTypes.func.isRequired,
  mode: PropTypes.func.isRequired,
};

export default Questions;
